import AOS from 'aos';
import 'aos/dist/aos.css';

const body = document.querySelector('body');
export function initGlobal() {
  const SCROLL_THRESHOLD = 150;
  let lastScrollY = 0;
  let ticking = false;
  function updateScrollState() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollY > SCROLL_THRESHOLD) {
      body.classList.add('is-scrolled');
    } else {
      body.classList.remove('is-scrolled');
    }

    // 스크롤 방향
    if (scrollY > lastScrollY && scrollY > SCROLL_THRESHOLD) {
      body.classList.add('is-scrolling-down');
      body.classList.remove('is-scrolling-up');
    } else if (scrollY < lastScrollY) {
      body.classList.add('is-scrolling-up');
      body.classList.remove('is-scrolling-down');
    }

    lastScrollY = scrollY <= 0 ? 0 : scrollY;
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  updateScrollState();

  document.addEventListener('click', () => {
    // 클릭하면 Drawer가 열릴 가능성이 있음 → 약간 지연 후 체크
    setTimeout(() => {
      const btn = document.querySelector(
        '.wc-block-mini-cart__drawer a.wc-block-mini-cart__footer-checkout .wc-block-components-button__text'
      );
      if (btn && btn.textContent !== '주문하기') {
        btn.textContent = '주문하기';
      }
    }, 50);
  });
}

export function initAos() {
  AOS.init({ once: true });
}

export function debounce(fn, wait = 150) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => {
      fn(...args);
    }, wait);
  };
}

export function _getTermFromHash(hash) {
  if (!hash) return null;
  const t = hash.replace('#', '').trim();
  return t || null;
}
